import { Theme } from '@mui/material';

import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const accordionStyles: AbgSxProps = {
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  '& > :last-child': {
    overflow: 'auto',
  },
  minHeight: '67px',
  boxShadow: 'none',
  borderRadius: '0 !important',
  borderBottom: '1px solid #C7C5C5',
  '.MuiAccordionSummary-root.Mui-expanded': {
    backgroundColor: '#000 !important',
    transition: 'transform 0.3s ease',
  },
  '.MuiAccordionDetails-root': {
    padding: '8px 0 0 !important',
  },
};

export const accordionSummaryStyles: AbgSxProps = {
  '.MuiAccordionSummary-content': {
    height: '36px !important',
    margin: '15px 0 !important',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    pr: 1,
  },
};

export const iconStyles = (isExpanded: boolean) => (theme: Theme) => ({
  width: '16px',
  height: '16px',
  fill: isExpanded
    ? theme.palette.text.primaryInverse
    : theme.palette.text.primary,
});

export const titleWrapperStyles: AbgSxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  paddingLeft: '8px',
};

export const titleStyles = (isExpanded: boolean) => (theme: Theme) => ({
  fontWeight: '500',
  color: isExpanded
    ? theme.palette.text.primaryInverse
    : theme.palette.text.primary,
});

export const subtitleStyles = (isExpanded: boolean) => ({
  color: isExpanded ? paletteBase.white80 : paletteBase.neutral400,
});

export const errorBannerStyles: AbgSxProps = {
  position: 'sticky',
  bottom: 0,
  backgroundColor: paletteBase.white100,
  boxShadow: '0px -2px 10px 0px #0000000F',
  zIndex: 1200,
};
